var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "editProjectRoot" }, [
    _c("div", { staticClass: "title" }, [
      _vm._v("Project: " + _vm._s(_vm.project.Name))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "dataRow" }, [
      _vm._v("Current event submission URL:")
    ]),
    _vm._v(" "),
    _c("div", [
      _c("code", { staticClass: "url" }, [
        _vm._v(_vm._s(_vm.project.SubmitURL))
      ])
    ]),
    _vm._v(" "),
    _c("div", [
      _c("input", {
        attrs: {
          type: "button",
          value: "Replace Submission Key",
          title:
            "Replaces the submission key with a new one (requires confirmation)"
        },
        on: { click: _vm.ReplaceSubmitKey }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "button", value: "Copy Submission URL" },
        on: { click: _vm.CopySubmitUrl }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "dataRow" }, [
      _vm._v("Max Event Age (Days): "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.maxEventAgeDays,
            expression: "maxEventAgeDays"
          }
        ],
        attrs: { type: "number", min: "0", max: "36500" },
        domProps: { value: _vm.maxEventAgeDays },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.maxEventAgeDays = $event.target.value
          }
        }
      }),
      _vm._v(" (0 to disable automatic Event deletion)")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "dataRow" },
      [
        _c("PropEdit", {
          attrs: {
            initialValue: _vm.cloneTo,
            spec: _vm.project.CloneToEditSpec
          },
          on: { valueChanged: _vm.onPropEditValueChanged }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "buttonRow" }, [
      _c("input", {
        attrs: { type: "button", value: "Commit Changes" },
        on: { click: _vm.Commit }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "button", value: "Delete Project" },
        on: { click: _vm.Remove }
      }),
      _vm._v(" "),
      _c("input", {
        ref: "cancelBtn",
        attrs: { type: "button", value: "Cancel" },
        on: { click: _vm.Cancel }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }